// // src/Loan/LoanCard.jsx
// import React, { useEffect, useState, useRef } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { useParams } from "react-router-dom";
// import { fetchLoanEmis, clearLoanEmis } from "../redux/slices/loan/loanEmiSlice";
// import { fetchAllLoans } from "../redux/slices/loan/loanReportSlice";
// import jsPDF from "jspdf";
// import Barcode from "react-barcode";
// import html2canvas from "html2canvas";
// import "../assets/Loan/LoanCard.css";
// import { fetchUserProfile } from "../redux/slices/branch/userProfileSlice";

// // Utils
// const formatDate = (dateStr) => {
//   if (!dateStr) return "-";
//   const date = new Date(dateStr);
//   return isNaN(date) ? dateStr : date.toLocaleDateString("en-GB");
// };
// const formatAmount = (amount) =>
//   !amount ? "Rs 0" : `Rs ${Number(amount).toLocaleString("en-IN")}`;

// const GroupLoanEmiCard = () => {
//   const { loanId } = useParams();
//   const dispatch = useDispatch();
//   const cardRef = useRef();

//   const { emis, loading: emiLoading, error: emiError } = useSelector(
//     (state) => state.loanEmi
//   );
//   const { loans, loading: loanLoading, error: loanError } = useSelector(
//     (state) => state.loanReport
//   );
//   const { profile } = useSelector((state) => state.userProfile);

//   const [company, setCompany] = useState(null);
//   const [photoUrl, setPhotoUrl] = useState(null);

//   const createdById = Number(localStorage.getItem("userId")) || 0;

//   // ✅ Fetch Profile
//   useEffect(() => {
//     dispatch(fetchUserProfile());
//   }, [dispatch]);

//   // ✅ Fetch Loan + Company
//   useEffect(() => {

//     if (loanId) {
//       dispatch(fetchLoanEmis(loanId));
//       if (loans.length === 0) dispatch(fetchAllLoans());
//     }

//     const fetchCompany = async () => {
//       try {
//         const res = await fetch(
//           `https://payyug.in/api/get-company?superAdminId=${profile?.superAdminId}`
//         );
//         const data = await res.json();
//         if (res.ok && data) {
//           if (data.logo) {
//             data.logoUrl = `https://payyug.in/${data.logo.replace(/^images\//, "")}`;
//           }
//           setCompany(data);
//         }
//       } catch (err) {
//         console.error("Error fetching company:", err);
//       }
//     };
//     if (profile?.superAdminId) fetchCompany();

//     return () => dispatch(clearLoanEmis());
//   }, [dispatch, loanId, loans.length, profile?.superAdminId]);

//   const loan = loans.find((l) => String(l.id) === String(loanId)) || null;
//   const emiAmountFromSchedule = emis?.[0]?.emiAmount || "NA";

//   // ✅ Fetch Customer Photo (filtered by 'photo' docName)
//   useEffect(() => {

//           const branchId = Number(localStorage.getItem("userId")) || 0;

//     const fetchCustomerPhoto = async () => {
//       try {
//         if (loan?.customerId && profile?.superAdminId) {
//           const res = await fetch(
//             `https://payyug.in/api/list-kyc?userId=${loan.customerId}&superAdminId=${profile.superAdminId}&createdById=${branchId}`
//           );
//           const data = await res.json();
//           if (res.ok && data.documents?.length > 0) {
//             const photoDoc = data.documents.find(
//               (doc) => doc.docName?.toLowerCase() === "photo"
//             );
//             if (photoDoc?.docImage) {
//               setPhotoUrl(`https://payyug.in/uploads/${photoDoc.docImage}`);
//             }
//           }
//         }
//       } catch (err) {
//         console.error("Failed to fetch customer photo:", err);
//       }
//     };

//     fetchCustomerPhoto();
//   }, [loan?.customerId, profile?.superAdminId, createdById]);

// const generatePDF = async () => {
//   const input = cardRef.current;
//   if (!input) return;

//   const pdf = new jsPDF("p", "mm", "a4");
//   const pageWidth = pdf.internal.pageSize.getWidth();
//   const pageHeight = pdf.internal.pageSize.getHeight();

//   const canvas = await html2canvas(input, {
//     scale: 2,
//     useCORS: true,
//     allowTaint: true,
//     scrollY: -window.scrollY,
//   });

//   const imgWidth = pageWidth - 20;      // 10mm left + 10mm right margin
//   const pageImageHeight = pageHeight - 20; // 10mm top + 10mm bottom margin

//   const totalImageHeight = (canvas.height * imgWidth) / canvas.width;

//   let renderedHeight = 0;

//   while (renderedHeight < totalImageHeight) {

//     // CREATE TEMPORARY CANVAS FOR EACH PAGE
//     const pageCanvas = document.createElement("canvas");
//     pageCanvas.width = canvas.width;
//     pageCanvas.height =
//       (pageImageHeight * canvas.width) / imgWidth;

//     const ctx = pageCanvas.getContext("2d");

//     // COPY PART OF FULL IMAGE → PAGE IMAGE
//     ctx.drawImage(
//       canvas,
//       0,
//       (renderedHeight * canvas.width) / imgWidth,
//       canvas.width,
//       pageCanvas.height,
//       0,
//       0,
//       canvas.width,
//       pageCanvas.height
//     );

//     const pageImgData = pageCanvas.toDataURL("image/png");
//     const pageImgHeight = (pageCanvas.height * imgWidth) / canvas.width;

//     if (renderedHeight === 0) {
//       // FIRST PAGE
//       pdf.addImage(pageImgData, "PNG", 10, 10, imgWidth, pageImgHeight);
//     } else {
//       // OTHER PAGES
//       pdf.addPage();
//       pdf.addImage(pageImgData, "PNG", 10, 10, imgWidth, pageImgHeight);
//     }

//     renderedHeight += pageImageHeight;
//   }

//   pdf.save(`LoanCard_${loan?.loanAccountNumber || loan?.loanNumber}.pdf`);
// };

//   if (loanLoading || emiLoading)
//     return <div className="branch-loan-card-container">Loading...</div>;
//   if (loanError || emiError)
//     return (
//       <div className="branch-loan-card-container">{loanError || emiError}</div>
//     );
//   if (!loan)
//     return (
//       <div className="branch-loan-card-container">
//         No loan found for Loan ID {loanId}
//       </div>
//     );

//   return (
//     <div>
//       <div className="branch-loan-card-container" ref={cardRef}>
//         {/* Header */}
//         <header className="branch-loan-card-header">
//           <div className="branch-loan-card-logo-box">
//             {company?.logoUrl && (
//               <img
//                 src={company.logoUrl}
//                 alt="Logo"
//                 className="branch-loan-card-logo"
//               />
//             )}
//           </div>

//           <div className="branch-loan-card-details-box">
//             <h2>{company?.name || "Company Name"}</h2>
//             <p>
//               <strong>CIN:</strong> {company?.cin || "-"}
//               <br />
//               <strong>Regt. Office:</strong> {company?.address || "-"}
//               <br />
//               <strong>Website:</strong> {company?.domain || "-"}
//               <br />
//               <strong>Contact:</strong> {company?.contact || "-"}
//               <br />
//               <strong>Email:</strong> {company?.email || "-"}
//             </p>
//           </div>

//           <div className="branch-loan-card-qr-box">
//             <img
//               // src={`https://api.qrserver.com/v1/create-qr-code/?size=100x100&data=${loanId}`}
//               src="/payyug_scanner2.jpg"
//               alt="QR Code"
//               className="branch-loan-card-qr"
//             />
//           </div>

//         </header>

//         {/* Title */}
//         <div className="branch-loan-card-title-section">
//           <div className="branch-loan-card-barcode-top">
//             <Barcode
//               value={loanId}
//               height={40}
//               displayValue={true}
//               fontSize={14}
//               margin={0}
//             />
//           </div>
//           <h3 className="branch-loan-card-title">Loan EMI Card</h3>
//         </div>

//         {/* Loan & Customer Details */}
//         <div className="branch-loan-card-loan-details">
//           <table className="branch-loan-card-detail-table">
//             <tbody>
//               <tr>
//                 <td>
//                   <strong>Customer Name:</strong> {loan.userName || "-"}
//                 </td>
//                 <td>
//                   <strong>Loan ID:</strong>{" "}
//                   {loan.loanAccountNumber || loan.loanNumber}
//                 </td>
//                 <td rowSpan="4" className="branch-loan-card-photo-cell">
//                   <img
//                     src={
//                       photoUrl ||
//                       "https://upload.wikimedia.org/wikipedia/commons/6/65/No-Image-Placeholder.svg"
//                     }
//                     alt="Customer"
//                     className="branch-loan-card-photo"
//                   />
//                 </td>
//               </tr>
//               {/* <tr>
//                 <td>
//                   <strong>Contact No:</strong> {loan.contactNo || "-"}
//                 </td>
//                 <td>
//                   <strong>Guardian Name:</strong> {loan.guardianName || "-"}
//                 </td>
//               </tr> */}
//               <tr>
//                 <td>
//                   <strong>Loan Amount:</strong> {formatAmount(loan.loanAmount)}
//                 </td>
//                 <td>
//                   <strong>Plan Name:</strong>{" "}
//                   {loan.loanService || loan.loanService || "-"}
//                 </td>
//               </tr>
//               <tr>
//                 <td>
//                   <strong>Number of EMI:</strong> {emis.length}
//                 </td>
//                 <td>
//                   <strong>EMI Amount:</strong>{" "}
//                   {formatAmount(emiAmountFromSchedule)}
//                 </td>
//               </tr>
//             </tbody>
//           </table>

//           <div className="branch-loan-card-branch-info">
//             <p>
//               <strong>Branch : </strong> {profile?.branchName || "-"}
//             </p>
//             <p>
//               <strong>Date : </strong> {new Date().toLocaleDateString("en-GB")}
//             </p>
//           </div>
//         </div>

//         {/* EMI Table */}
//         <section className="branch-loan-card-table-section">
//           <h4>EMI Schedule Terms</h4>
//           <table className="branch-loan-card-table">
//             <thead>
//               <tr>
//                 <th>Sr. No</th>
//                 <th>Loan EMI Date</th>
//                 <th>Interest</th>
//                 <th>Principal</th>
//                 <th>EMI</th>
//                 <th>Receiving Date</th>
//                 <th>Received Amt</th>
//                 <th>Staff Sign</th>
//                 <th>Member Sign</th>
//               </tr>
//             </thead>
//             <tbody>
//               {emis.map((emi, idx) => (
//                 <tr key={idx}>
//                   <td>{idx + 1}</td>
//                   <td>{formatDate(emi.dueDate)}</td>
//                   <td>{formatAmount(emi.interestComponent)}</td>
//                   <td>{formatAmount(emi.principalComponent)}</td>
//                   <td>{formatAmount(emi.emiAmount)}</td>
//                   <td></td>
//                   <td></td>
//                   <td></td>
//                   <td></td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </section>

//         {/* Footer */}
//         <footer className="branch-loan-card-footer">
//           <div>
//             Member Signature
//             <br />
//             (सदस्य के हस्ताक्षर)
//           </div>
//           <div>
//             Spouse Signature
//             <br />
//             (जीवनसाथी के हस्ताक्षर)
//           </div>

//           <div>
//             Branch Seal With Signature
//             <br />
//             (शाखा मोहर के साथ हस्ताक्षर)
//           </div>
//         </footer>
//       </div>

//       {/* PDF Button */}
//       <div style={{ textAlign: "center" }}>
//         <button onClick={generatePDF} className="branch-loan-card-download-btn">
//           📄 Download PDF
//         </button>
//       </div>
//     </div>
//   );
// };

// export default GroupLoanEmiCard;

import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import "../assets/Loan/LoanCard.css";
import { fetchUserProfile } from "../redux/slices/branch/userProfileSlice";
import axios from "axios";

/* ===================== Utils ===================== */
const formatDate = (dateStr) => {
  if (!dateStr) return "-";
  const date = new Date(dateStr);
  return isNaN(date) ? dateStr : date.toLocaleDateString("en-GB");
};

const formatAmount = (amount) =>
  !amount ? "Rs 0" : `Rs ${Number(amount).toLocaleString("en-IN")}`;

const getPublicImageUrl = (imagePath) => {
  if (!imagePath) return null;
  if (/^https?:\/\//i.test(imagePath)) return imagePath;

  const cleanPath = String(imagePath).replace(/^\/+/, "");
  if (cleanPath.startsWith("images/uploads/")) {
    return `https://payyug.in/uploads/${cleanPath.replace(/^images\/uploads\//, "")}`;
  }
  if (cleanPath.startsWith("uploads/")) {
    return `https://payyug.in/${cleanPath}`;
  }
  return `https://payyug.in/uploads/${cleanPath}`;
};

/* ===================== Component ===================== */
const GroupLoanEmiCard = () => {
  const { loanId } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const cardRef = useRef();

  const location = useLocation();
  const loan = location.state?.loan;

  const { profile } = useSelector((state) => state.userProfile);

  const [emis, setEmis] = useState([]);
  const [company, setCompany] = useState(null);
  const [photoUrl, setPhotoUrl] = useState(null);
  const [memberSignatureUrl, setMemberSignatureUrl] = useState(null);
  const [customerDetails, setCustomerDetails] = useState(null);

  const [branchSealUrl, setBranchSealUrl] = useState(null);
  const [branchSignUrl, setBranchSignUrl] = useState(null);

  const branchId = Number(localStorage.getItem("userId")) || 0;
  const responseLoan = emis[0]?.loanAccount;
  const responseMember = emis[0]?.member;
  const displayLoan = responseLoan || loan || {};
  const displayMember = responseMember || loan?.member || {};
  const companyAddressParts = String(company?.address || "")
    .split(",")
    .map((part) => part.trim())
    .filter(Boolean);
  const companyAddressLines = companyAddressParts.length > 2
    ? [companyAddressParts.slice(0, 2).join(", "), companyAddressParts.slice(2).join(", ")]
    : [companyAddressParts.join(", ") || "-"];
  const totalInterestApprox = emis.reduce(
    (total, emi) => total + (Number(emi.interestComponent) || 0),
    0,
  );
  const coBorrowerSignatureUrl = getPublicImageUrl(
    displayLoan?.coBorrowerSignature ||
      displayLoan?.coBorrowerSignatureImage ||
      displayLoan?.guarantorSignature ||
      displayLoan?.guarantorSignatureImage ||
      displayLoan?.guarantorDetails?.signatureImage,
  );

  /* ===================== Fetch Profile ===================== */
  useEffect(() => {
    dispatch(fetchUserProfile());
  }, [dispatch]);

  /* ===================== Fetch Company ===================== */
  useEffect(() => {
    if (!profile?.superAdminId) return;

    const fetchCompany = async () => {
      try {
        const res = await fetch(
          `https://payyug.in/api/get-company?superAdminId=${profile.superAdminId}`,
        );
        const data = await res.json();
        if (res.ok && data) {
          if (data.logo) {
            data.logoUrl = `https://payyug.in/${data.logo.replace(/^images\//, "")}`;
          }
          if (data.qrCodeImage) {
            data.qrCodeUrl = `https://payyug.in/${data.qrCodeImage.replace(/^images\//, "")}`;
          }
          setCompany(data);
        }
      } catch (err) {
        console.error("Error fetching company:", err);
      }
    };

    fetchCompany();
  }, [profile?.superAdminId]);

  /* ===================== Fetch EMI List ===================== */
  useEffect(() => {
    if (!loanId || !profile?.superAdminId) return;

    let cancelled = false;

    const fetchEmis = async () => {
      try {
        const res = await axios.get(
          `https://payyug.in/api/group-loan/emi/list-filter?loanId=${loanId}`,
          {
            params: {
              superAdminId: profile.superAdminId,
              branchId: loan?.branchId || branchId,
              grouploanAccountId: loan?.id || loanId,
              limit: 100,
            },
          },
        );
        if (!cancelled) setEmis(res.data?.data || []);
      } catch (err) {
        console.error("Fetch EMI Error:", err);
        if (!cancelled) setEmis([]);
      }
    };

    fetchEmis();
    return () => {
      cancelled = true;
    };
  }, [loanId, profile?.superAdminId, loan?.branchId, loan?.id]);

  /* ===================== Fetch Customer Photo & Details ===================== */
  useEffect(() => {
    const customerUserId = displayMember?.userId;
    if (!customerUserId || !profile?.superAdminId) return;

    if (displayMember?.customerPhoto) {
      setPhotoUrl(getPublicImageUrl(displayMember.customerPhoto));
    }
    if (displayMember?.signatureImage) {
      setMemberSignatureUrl(getPublicImageUrl(displayMember.signatureImage));
    }

    const fetchCustomerDetails = async () => {
      try {
        const res = await fetch(
          `https://payyug.in/api/customers-get-userId?userId=${customerUserId}&branchId=${branchId}`,
        );
        const data = await res.json();
        setCustomerDetails(data.data);
      } catch (err) {
        console.error("Customer fetch error:", err);
      }
    };

    const fetchCustomerPhoto = async () => {
      try {
        const res = await fetch(
          `https://payyug.in/api/list-kyc?userId=${customerUserId}&superAdminId=${profile.superAdminId}&createdById=${branchId}`,
        );
        const data = await res.json();
        if (res.ok && data.documents?.length > 0) {
          const photoDoc = data.documents.find(
            (doc) => doc.docName?.toLowerCase() === "photo",
          );
          if (photoDoc?.docImage) {
            setPhotoUrl(getPublicImageUrl(photoDoc.docImage));
          }
        }
      } catch (err) {
        console.error("Failed to fetch customer photo:", err);
      }
    };

    fetchCustomerDetails();
    fetchCustomerPhoto();
  }, [
    displayMember?.userId,
    displayMember?.customerPhoto,
    displayMember?.signatureImage,
    profile?.superAdminId,
    branchId,
  ]);

  /* ===================== Fetch Stamp & Sign ===================== */
  useEffect(() => {
    const fetchSealSign = async () => {
      if (!profile?.superAdminId) return;

      try {
        const res = await axios.get(
          `https://payyug.in/api/list/stamp?superAdminId=${profile?.superAdminId}&category=Group Loan Card`,
        );

        const responseData = res?.data?.data;
        const stampRecord = Array.isArray(responseData)
          ? responseData.flat(Infinity).find((record) => record && (record.file || record.type))
          : responseData?.data?.[0] || responseData;

        setBranchSealUrl(getPublicImageUrl(stampRecord?.file));
        setBranchSignUrl(
          getPublicImageUrl(
            stampRecord?.type || stampRecord?.signature || stampRecord?.sign,
          ),
        );
      } catch (error) {
        console.error("API Fetch Error:", error);
      }
    };

    fetchSealSign();
  }, [profile?.superAdminId]);

  /* ===================== Derived Values ===================== */
  const emiAmountFromSchedule = emis && emis.length > 0 ? emis[0].emiAmount : 0;
  const cardFileBaseName = `${displayLoan?.memberName || displayMember?.fullName || "Customer"}_GroupLoanCard`;

  /* ===================== One-page PDF Generator ===================== */
  const generatePDF = async () => {
    const input = cardRef.current;
    if (!input) return;

    const downloadBtns = document.querySelectorAll(
      ".branch-loan-card-download-btn",
    );
    downloadBtns.forEach((btn) => (btn.style.display = "none"));

    try {
      await Promise.all(
        Array.from(input.querySelectorAll("img")).map((img) => {
          if (img.complete) return Promise.resolve();
          return new Promise((resolve) => {
            img.onload = resolve;
            img.onerror = resolve;
          });
        }),
      );
      const canvas = await html2canvas(input, {
        scale: 2,
        useCORS: true,
        backgroundColor: "#ffffff",
        scrollY: -window.scrollY,
      });
      const pdf = new jsPDF("p", "mm", "a4", true);
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();
      const margin = 5;
      const maxWidth = pageWidth - margin * 2;
      const maxHeight = pageHeight - margin * 2;
      const scale = Math.min(maxWidth / canvas.width, maxHeight / canvas.height);
      const imageWidth = canvas.width * scale;
      const imageHeight = canvas.height * scale;
      const x = (pageWidth - imageWidth) / 2;
      const y = (pageHeight - imageHeight) / 2;

      pdf.addImage(
        canvas.toDataURL("image/jpeg", 0.95),
        "JPEG",
        x,
        y,
        imageWidth,
        imageHeight,
        undefined,
        "FAST",
      );
      pdf.save(`${cardFileBaseName}.pdf`);
    } catch (error) {
      console.error("PDF generation error:", error);
    } finally {
      downloadBtns.forEach((btn) => (btn.style.display = "inline-block"));
    }
  };

  /* ===================== Print card as a single A4 page ===================== */
  const triggerPrintElement = async (elementRef, title = "Print_Document") => {
    const input = elementRef.current;
    if (!input) return;

    try {
      await Promise.all(
        Array.from(input.querySelectorAll("img")).map((img) => {
          if (img.complete) return Promise.resolve();
          return new Promise((resolve) => {
            img.onload = resolve;
            img.onerror = resolve;
          });
        }),
      );
      const canvas = await html2canvas(input, {
        scale: 1.5,
        useCORS: true,
        backgroundColor: "#ffffff",
        scrollY: -window.scrollY,
      });
      // JPEG keeps the print preview small and carries the card's colored
      // backgrounds inside the image, even when browser background printing is off.
      const imageUrl = canvas.toDataURL("image/jpeg", 0.95);

      const appRoot = document.getElementById("root");
      const previousRootVisibility = appRoot?.style.visibility;
      const previousDocumentTitle = document.title;
      const previousVisibility = input.style.visibility;
      let cleanedUp = false;
      const cleanupPrintPreview = () => {
        if (cleanedUp) return;
        cleanedUp = true;
        document.title = previousDocumentTitle;
        if (appRoot) appRoot.style.visibility = previousRootVisibility;
        input.style.visibility = previousVisibility;
        document.getElementById("print-iframe")?.remove();
      };

      const existingIframe = document.getElementById("print-iframe");
      existingIframe?.remove();

      const iframe = document.createElement("iframe");
      iframe.id = "print-iframe";
      iframe.style.position = "fixed";
      iframe.style.left = "0";
      iframe.style.top = "0";
      iframe.style.width = "100vw";
      iframe.style.height = "100vh";
      iframe.style.border = "0";
      iframe.style.zIndex = "2147483647";
      document.body.appendChild(iframe);

      const doc = iframe.contentWindow.document;
      doc.open();
      doc.write(`
        <!DOCTYPE html>
        <html>
          <head>
            <title></title>
            <style>
              @page { size: A4 portrait; margin: 0; }
              html, body {
                width: 210mm;
                height: 297mm;
                margin: 0;
                padding: 0;
                overflow: hidden;
                background: #fff;
                -webkit-print-color-adjust: exact;
                print-color-adjust: exact;
              }
              img {
                display: block;
                width: 200mm;
                height: 287mm;
                margin: 5mm auto;
                object-fit: contain;
                -webkit-print-color-adjust: exact;
                print-color-adjust: exact;
              }
            </style>
          </head>
          <body><img id="print-card" alt="Loan card"></body>
        </html>
      `);
      doc.close();
      doc.title = title;

      const printImage = doc.getElementById("print-card");
      printImage.onload = () => {
        if (appRoot) appRoot.style.visibility = "hidden";
        input.style.visibility = "hidden";
        iframe.contentWindow.onafterprint = cleanupPrintPreview;
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            // Chrome's Save as PDF uses the top-level page title for its filename.
            document.title = title;
            iframe.contentWindow.focus();
            iframe.contentWindow.print();
          });
        });
      };
      printImage.onerror = cleanupPrintPreview;
      printImage.src = imageUrl;
    } catch (error) {
      console.error("Print generation error:", error);
    }
  };

  const handlePrint = () => {
    triggerPrintElement(cardRef, cardFileBaseName);
  };

  /* ===================== Safety ===================== */
  if (!loanId) {
    return <div className="branch-loan-card-container">No loan ID provided.</div>;
  }

  return (
    <div className="loan-card-page-shell">
      <div className="loan-card-top-actions">
        <button
          onClick={() => navigate(-1)}
          className="branch-loan-card-download-btn loan-card-back-btn"
          style={{ cursor: "pointer" }}
        >
          ← Back
        </button>
      </div>

      <div
        className="branch-loan-card-container loan-card-redesign"
        ref={cardRef}
      >
        {/* Header */}
        <header className="branch-loan-card-header">
          <div className="branch-loan-card-logo-box">
            {company?.logoUrl && (
              <img
                src={company.logoUrl}
                alt="Logo"
                className="branch-loan-card-logo"
              />
            )}
            <span className="branch-loan-card-brand-name">{company?.name || "Loan Management System"}</span>
          </div>

          <div className="branch-loan-card-title-banner">
            <h2>LOAN EMI CARD</h2>
            <span>(REPAYMENT SCHEDULE)</span>
          </div>

          <div className="branch-loan-card-company-meta">
            <div>
              <strong>{company?.name || "Loan Management System"}</strong>
              {companyAddressLines.map((line, index) => <span key={index}>{line}</span>)}
              <span>CIN: {company?.cin || "-"}</span>
              <span>Email: {company?.email || "-"}</span>
            </div>
            <div className="branch-loan-card-qr-box">
              {company?.qrCodeUrl && <img src={company.qrCodeUrl} alt="QR Code" className="branch-loan-card-qr" />}
              <small>SCAN TO PAY</small>
            </div>
          </div>
        </header>

        <section className="branch-loan-card-profile-grid">
          <div className="branch-loan-card-profile-panel">
            <h3>Customer / Member Details</h3>
            <dl>
              <div><dt>Member Name</dt><dd>{displayLoan?.memberName || displayMember?.fullName || "-"}</dd></div>
              <div><dt>Father Name</dt><dd>{displayMember?.fatherName || displayMember?.father_name || customerDetails?.fatherName || customerDetails?.father_name || "-"}</dd></div>
              <div><dt>Group Name</dt><dd>{displayLoan?.groupName || "-"}</dd></div>
              <div><dt>Member ID</dt><dd>{displayMember?.userId || displayMember?.customerId || displayLoan?.memberId || "-"}</dd></div>
              <div><dt>Address</dt><dd>{customerDetails?.address || displayMember?.address || "-"}</dd></div>
              <div><dt>Mobile No.</dt><dd>{displayMember?.mobileNumber || customerDetails?.mobileNumber || "-"}</dd></div>
            </dl>
          </div>
          <div className="branch-loan-card-member-photo">
            <img src={photoUrl || "/user.png"} alt="Member" />
            <span>{displayMember?.userId || displayMember?.customerId || displayLoan?.memberId || "-"}</span>
          </div>
          <div className="branch-loan-card-profile-panel">
            <h3>Loan Details</h3>
            <dl>
              <div><dt>Loan Account No.</dt><dd>{displayLoan?.loanAccountNumber || displayLoan?.loanNumber || "-"}</dd></div>
              <div><dt>Loan Type</dt><dd>{displayLoan?.loanType || "-"}</dd></div>
              <div><dt>Loan Amount</dt><dd>{formatAmount(displayLoan?.loanAmount)}</dd></div>
              <div><dt>Number of EMI / Tenure</dt><dd>{displayLoan?.loanTenure || emis.length || "-"}</dd></div>
              <div><dt>EMI Amount</dt><dd>{formatAmount(displayLoan?.loanEmiAmount || emiAmountFromSchedule)}</dd></div>
              <div><dt>Interest Rate (p.a.)</dt><dd>{displayLoan?.loanRoi ?? displayLoan?.interestRate ?? "-"}%</dd></div>
              <div><dt>Disbursal Date</dt><dd>{formatDate(displayLoan?.disbursalDate)}</dd></div>
              <div><dt>Branch</dt><dd>{profile?.branchName || displayMember?.branchName || "-"}</dd></div>
            </dl>
          </div>
        </section>

        {/* EMI Table */}
        <section className="branch-loan-card-table-section">
          <h4>EMI Repayment Schedule (Total {emis.length} EMIs)</h4>
          <div className="branch-loan-card-schedule-columns">
            {[emis.slice(0, 30), emis.slice(30, 60)].map((schedule, columnIndex) => (
              <table className="branch-loan-card-table" key={columnIndex}>
                <thead>
                  <tr>
                    <th>Sr.</th>
                    <th>Due Date</th>
                    <th>EMI</th>
                    <th>Paid Date</th>
                    <th>Received</th>
                    <th>Sign</th>
                  </tr>
                </thead>
                <tbody>
                  {schedule.map((emi, index) => {
                    const idx = columnIndex * 30 + index;
                    const paymentAmounts = [1, 2, 3, 4, 5]
                      .map((paymentNo) => Number(emi[`payment${paymentNo}`]) || 0)
                      .filter((amount) => amount > 0);
                    const receivedAmount =
                      emi.paidAmount ??
                      emi.lastPaidAmount ??
                      emi.partiallyPaidAmount ??
                      (paymentAmounts.length ? paymentAmounts.reduce((sum, amount) => sum + amount, 0) : null);
                    const receivedDate =
                      emi.paidDate ||
                      emi.lastPaidDate ||
                      [5, 4, 3, 2, 1]
                        .map((paymentNo) => emi[`payment${paymentNo}Date`])
                        .find(Boolean);
                    return (
                      <tr key={emi.id || idx} className="print-row">
                        <td>{idx + 1}</td>
                        <td>{formatDate(emi.dueDate)}</td>
                        <td>{formatAmount(emi.emiAmount)}</td>
                        <td>{receivedDate ? formatDate(receivedDate) : ""}</td>
                        <td>{receivedAmount !== null && receivedAmount !== undefined && receivedAmount !== "" ? formatAmount(receivedAmount) : ""}</td>
                        <td></td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            ))}
          </div>
        </section>

        <section className="branch-loan-card-summary">
          <div className="branch-loan-card-summary-box">
            <h4>Loan Summary</h4>
            <dl>
              <div><dt>Loan Amount</dt><dd>{formatAmount(displayLoan?.loanAmount)}</dd></div>
              <div><dt>Total Interest (Approx.)</dt><dd>{formatAmount(totalInterestApprox)}</dd></div>
              <div><dt>Total Payable</dt><dd>{formatAmount(displayLoan?.loanPayable)}</dd></div>
              <div><dt>Total EMI</dt><dd>{displayLoan?.loanTenure || emis.length || "-"}</dd></div>
              <div><dt>EMI Amount</dt><dd>{formatAmount(displayLoan?.loanEmiAmount || emiAmountFromSchedule)}</dd></div>
              <div><dt>Disbursal Date</dt><dd>{formatDate(displayLoan?.disbursalDate)}</dd></div>
              <div><dt>Branch</dt><dd>{profile?.branchName || "-"}</dd></div>
            </dl>
          </div>
          <div className="branch-loan-card-summary-box branch-loan-card-instructions">
            <h4>Important Instructions</h4>
            <ol>
              <li>Please pay EMI on or before the due date.</li>
              <li>In case of delay, penal charges as per company policy will be applied.</li>
              <li>This is a computer generated schedule and does not require signature on each installment.</li>
              <li>For any discrepancy, please contact your branch.</li>
              <li>This loan is subject to the terms and conditions of {company?.name || "the company"}.</li>
              <li>Prepayment / foreclosure rules apply as per company policy.</li>
            </ol>
          </div>
        </section>

        {/* Footer */}
        <footer className="branch-loan-card-footer print-row">
          <div className="box-size">
            <strong className="branch-loan-card-signature-title">Member Signature</strong>
            <span className="branch-loan-card-signature-hindi">(सदस्य के हस्ताक्षर)</span>
            <div className="branch-loan-card-signature-slot">
              {memberSignatureUrl && (
              <img
                src={memberSignatureUrl}
                alt="Member signature"
                className="branch-loan-card-footer-signature"
              />
              )}
            </div>
          </div>
          <div className="box-size">
            <strong className="branch-loan-card-signature-title">Co-Borrower Signature</strong>
            <span className="branch-loan-card-signature-hindi">(सह-उधारकर्ता के हस्ताक्षर)</span>
            <div className="branch-loan-card-signature-slot">
            {coBorrowerSignatureUrl ? (
              <img
                src={coBorrowerSignatureUrl}
                alt="Co-borrower signature"
                className="branch-loan-card-footer-signature"
              />
            ) : null}
            </div>
          </div>

          <div className="box-size">
            <strong className="branch-loan-card-signature-title">President / Secretary Signature</strong>
            <span className="branch-loan-card-signature-hindi">(अध्यक्ष / सचिव के हस्ताक्षर)</span>
            <div className="branch-loan-card-signature-slot">
            {branchSignUrl && (
              <img
                src={branchSignUrl}
                alt="President or secretary signature"
                className="branch-loan-card-footer-signature"
              />
            )}
            </div>
          </div>
          <div className="footer-seal-sign box-size">
            <strong className="branch-loan-card-signature-title">Branch Seal &amp; Signature</strong>
            <span className="branch-loan-card-signature-hindi">(शाखा मोहर के साथ हस्ताक्षर)</span>
            <div className="branch-loan-card-branch-assets">
              <div className="branch-loan-card-seal-slot">
                {branchSealUrl && <img src={branchSealUrl} alt="Branch seal" />}
              </div>
              <div className="branch-loan-card-signature-slot">
                {branchSignUrl && <img src={branchSignUrl} alt="Branch signature" className="branch-loan-card-footer-signature" />}
              </div>
            </div>
          </div>
        </footer>

        <footer className="branch-loan-card-wave-footer">
          <div>
            {company?.name || "Loan Management System"} | CIN:{" "}
            {company?.cin || "N/A"} | Contact: {company?.contact || "N/A"}
          </div>
          <svg
            viewBox="0 0 500 80"
            preserveAspectRatio="none"
            aria-hidden="true"
          >
            <path
              d="M0,80 L0,30 Q150,0 280,45 T500,20 L500,80 Z"
              fill="#38bdf8"
            />
            <path
              d="M0,80 L0,45 Q160,15 310,55 T500,35 L500,80 Z"
              fill="#0284c7"
            />
            <path
              d="M0,80 L0,55 Q180,25 340,65 T500,45 L500,80 Z"
              fill="#0f172a"
            />
          </svg>
        </footer>
      </div>

      {/* Buttons */}
      <div
        style={{
          textAlign: "center",
          display: "flex",
          justifyContent: "center",
          gap: "12px",
          marginTop: "16px",
        }}
      >
        <button
          onClick={handlePrint}
          className="branch-loan-card-download-btn"
          style={{ cursor: "pointer" }}
        >
          🖨️ Print Card
        </button>

        <button
          onClick={generatePDF}
          className="branch-loan-card-download-btn"
          style={{ cursor: "pointer" }}
        >
          📄 Download PDF
        </button>
      </div>
    </div>
  );
};

export default GroupLoanEmiCard;
